module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/34f00bb5263523cbbe58a183d80f721a.png";